import { SET_FILE_ID, UPDATE_IMPORT_STATUS } from '../actions/ui';

export default function(state = {}, action) {
  switch (action.type) {
  case SET_FILE_ID: {
    return {
      ...state,
      selectedFileId: action.id
    };
  }
  case UPDATE_IMPORT_STATUS: {
    return {
      ...state,
      importStatus: action.status
    };
  }
  default:
    return { ...state };
  }
}